import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsCircleLarge, vsLoading } from '@deephaven/icons';
import "./LoadingSpinner.css";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function LoadingSpinner(_ref) {
  var {
    className = '',
    'data-testid': dataTestId
  } = _ref;
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('loading-spinner fa-layers', className),
    "data-testid": dataTestId,
    children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
      icon: vsCircleLarge,
      className: "text-white-50"
    }), /*#__PURE__*/_jsx(FontAwesomeIcon, {
      icon: vsLoading,
      className: "text-primary",
      spin: true
    })]
  });
}
export default LoadingSpinner;
//# sourceMappingURL=LoadingSpinner.js.map